import React from "react";

const Promotesvg = ({favCount}) => {
  return (
    <>
     <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    id="Layer_1"
    data-name="Layer 1"
    viewBox="0 0 204 57"
  >
    <defs>
      <linearGradient
        id="linear-gradient"
        x1={35.02}
        x2={21}
        y1={45.54}
        y2={16.45}
        gradientTransform="matrix(1 0 0 -1 0 60)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#10e7f9" />
        <stop offset={1} stopColor="#307af5" />
      </linearGradient>
      <linearGradient
        xlinkHref="#linear-gradient"
        id="linear-gradient-2"
        x1={41.36}
        x2={27.34}
        y1={42.48}
        y2={13.39}
      />
      <linearGradient
        xlinkHref="#linear-gradient"
        id="linear-gradient-3"
        x1={45.83}
        x2={31.81}
        y1={40.32}
        y2={11.24}
      />
      <linearGradient
        xlinkHref="#linear-gradient"
        id="linear-gradient-4"
        x1={39.7}
        x2={25.68}
        y1={43.28}
        y2={14.19}
      />
      <style>{".cls-6{fill:#011367}"}</style>
    </defs>
    <rect
      id="Rectangle"
      width={203}
      height={56}
      x={0.5}
      y={0.5}
      rx={10}
      style={{
        fill: "#fff",
        stroke: "#347ef0",
      }}
    />
    <g id="Full_logo" data-name="Full logo">
      <g id="Logo">
        <path
          d="M43 23.11a5.12 5.12 0 0 0-2.8-4.56 5.49 5.49 0 0 0-5.54-4.14A4.89 4.89 0 0 0 27.49 13a4.86 4.86 0 0 0-7.15 1.4 5.49 5.49 0 0 0-5.54 4.15 5.07 5.07 0 0 0-2.8 4.58 6.23 6.23 0 0 0-.84 8.17 6 6 0 0 0 3.38 8.21 5.13 5.13 0 0 0 5.31 4.92 4.86 4.86 0 0 0 7.66.06 4.88 4.88 0 0 0 7.67-.06 5.12 5.12 0 0 0 5.31-4.92 6 6 0 0 0 3.38-8.21 6.26 6.26 0 0 0-.87-8.19ZM21.35 16A3.32 3.32 0 0 1 27 14.6v6.57h-5.6c-.05-1.82-.03-3.43-.05-5.17ZM14.5 33.87v3.91a4.29 4.29 0 0 1-1.56-6.43H27v2.52ZM36 37h-9v5.1a3.32 3.32 0 0 1-6 1.2V40h1a2 2 0 1 0 1.82-2.76A2 2 0 0 0 22 38.4h-2.63v4.48a3.66 3.66 0 0 1-3.31-3.62s0-3.52 0-3.86H36a2 2 0 1 1 0 1.6Zm-12.15 1.45a.74.74 0 1 1 0 1.47.74.74 0 0 1 0-1.47ZM32 29.8H12a4.66 4.66 0 0 1 1.59-6 3.26 3.26 0 0 1 1-3.27v6.76h7.73a2 2 0 1 0 0-1.56H16.2v-5.59A3.81 3.81 0 0 1 19.77 16v6.74h16.85a2 2 0 1 1 0 1.55h-9.69v4h5a2 2 0 1 1 0 1.56Zm-7.73-4a.74.74 0 0 1 0 1.47.74.74 0 0 1-.05-1.5Z"
          style={{
            fill: "url(#linear-gradient)",
          }}
          transform="translate(-.5 -.5)"
        />
        <path
          d="M38.48 24.24a.74.74 0 0 0 0-1.47.74.74 0 0 0 0 1.47Z"
          style={{
            fill: "url(#linear-gradient-2)",
          }}
          transform="translate(-.5 -.5)"
        />
        <path
          d="M37.87 35.47a.73.73 0 0 0 0 1.46.73.73 0 0 0 0-1.46Z"
          style={{
            fill: "url(#linear-gradient-3)",
          }}
          transform="translate(-.5 -.5)"
        />
        <path
          d="M33.77 28.29a.74.74 0 0 0 0 1.47.74.74 0 0 0 0-1.47Z"
          style={{
            fill: "url(#linear-gradient-4)",
          }}
          transform="translate(-.5 -.5)"
        />
      </g>
      <g id="logo_Text" data-name="logo Text">
        <path
          d="M56.24 14.16H52.5v2.72h3.56v1.06H52.5v3.56h-1.1v-8.4h4.84ZM58.21 18.98a2 2 0 0 0 .73 1.25 2.39 2.39 0 0 0 1.44.44 1.88 1.88 0 0 0 1.73-.87l.89.5a2.93 2.93 0 0 1-2.64 1.36 3.19 3.19 0 0 1-2.33-.89 3.34 3.34 0 0 1 0-4.53 3 3 0 0 1 2.27-.9 2.77 2.77 0 0 1 2.15.94 3.21 3.21 0 0 1 .83 2.22 3.89 3.89 0 0 1 0 .47Zm2.08-2.65a2 2 0 0 0-2.08 1.74h4a2 2 0 0 0-.67-1.3 2 2 0 0 0-1.25-.44ZM69.43 15.5h1v6h-1v-1a2.55 2.55 0 0 1-2.27 1.19 2.87 2.87 0 0 1-2.14-.92 3.25 3.25 0 0 1 0-4.47 2.84 2.84 0 0 1 2.14-.93 2.55 2.55 0 0 1 2.27 1.13Zm-2.13 5.15a2.09 2.09 0 0 0 2.13-2.15 2.14 2.14 0 0 0-3.65-1.52 2.07 2.07 0 0 0-.61 1.52 2.15 2.15 0 0 0 .61 1.54 2.11 2.11 0 0 0 1.52.61ZM75.32 16.5h-1.59v3.25a1 1 0 0 0 .16.64.78.78 0 0 0 .54.19h.89v.92a3.06 3.06 0 0 1-2-.22 1.66 1.66 0 0 1-.64-1.52V16.5H71.5v-1h1.19v-1.37l1-.31v1.68h1.59ZM80.73 15.5h1v6h-1v-.86a2.12 2.12 0 0 1-1.94 1 2.24 2.24 0 0 1-1.69-.66 2.53 2.53 0 0 1-.6-1.8V15.5h1v3.62a1.58 1.58 0 0 0 .39 1.14 1.46 1.46 0 0 0 1.09.4 1.7 1.7 0 0 0 1.26-.48 2.08 2.08 0 0 0 .48-1.5ZM84.41 16.5a1.87 1.87 0 0 1 1.87-1.12v1.12a2 2 0 0 0-1.32.41 1.72 1.72 0 0 0-.55 1.43v3.16h-1v-6h1ZM87.71 18.98a2 2 0 0 0 .73 1.25 2.35 2.35 0 0 0 1.44.44 1.89 1.89 0 0 0 1.73-.87l.89.5a3 3 0 0 1-2.64 1.36 3.17 3.17 0 0 1-2.36-.89 3.34 3.34 0 0 1 0-4.53 3 3 0 0 1 2.26-.9 2.75 2.75 0 0 1 2.15.94 3.21 3.21 0 0 1 .86 2.22 3.83 3.83 0 0 1 0 .47Zm2.07-2.65a2 2 0 0 0-1.39.48 2 2 0 0 0-.68 1.26h4a2 2 0 0 0-.68-1.3 2 2 0 0 0-1.25-.44ZM98.93 13.1h1v8.4h-1v-1a2.56 2.56 0 0 1-2.27 1.19 2.89 2.89 0 0 1-2.16-.95 3.25 3.25 0 0 1 0-4.47 2.86 2.86 0 0 1 2.15-.93 2.56 2.56 0 0 1 2.28 1.16Zm-2.14 7.55a2.11 2.11 0 0 0 1.53-.61 2.15 2.15 0 0 0 .61-1.54 2.07 2.07 0 0 0-.61-1.52 2.05 2.05 0 0 0-1.53-.63 2.12 2.12 0 0 0-2.12 2.15 2.11 2.11 0 0 0 .61 1.54 2.08 2.08 0 0 0 1.51.61ZM109.62 20.74a3.2 3.2 0 0 1-4.49 0 3.21 3.21 0 0 1 0-4.48 3.2 3.2 0 0 1 4.49 0 3.19 3.19 0 0 1 0 4.48Zm-2.25-.1a2.14 2.14 0 1 0 0-4.28 2 2 0 0 0-1.5.62 2.2 2.2 0 0 0 0 3 2 2 0 0 0 1.5.66ZM114.76 15.34a2.21 2.21 0 0 1 1.69.68 2.46 2.46 0 0 1 .64 1.8v3.68h-1v-3.62a1.54 1.54 0 0 0-.39-1.13 1.46 1.46 0 0 0-1.09-.41 1.67 1.67 0 0 0-1.26.49 2 2 0 0 0-.48 1.49v3.18h-1v-6h1v.86a2.12 2.12 0 0 1 1.89-1.02ZM57.85 40.5H53.5l-.7 2h-2.3l3.91-10.9h2.55l3.91 10.9h-2.31Zm-.59-1.74-1.57-4.55-1.58 4.55ZM64.5 31.65V42.5h-2.15V31.65ZM74.09 31.65v1.76h-2.9v9.09h-2.18v-9.09h-2.9v-1.76ZM76.36 42.13a4.08 4.08 0 0 1-1.57-1.57 4.72 4.72 0 0 1-.57-2.34 4.52 4.52 0 0 1 .59-2.34 3.94 3.94 0 0 1 1.6-1.56 4.86 4.86 0 0 1 4.53 0 4 4 0 0 1 1.56 1.56 4.62 4.62 0 0 1 .59 2.34 4.57 4.57 0 0 1-.59 2.34 4.17 4.17 0 0 1-1.63 1.57 5 5 0 0 1-4.54 0Zm3.37-1.63a2.15 2.15 0 0 0 .83-.86 2.87 2.87 0 0 0 .32-1.4 2.64 2.64 0 0 0-.65-1.9 2.13 2.13 0 0 0-1.58-.66 2.09 2.09 0 0 0-1.57.66 2.66 2.66 0 0 0-.63 1.9 2.76 2.76 0 0 0 .61 1.9 2 2 0 0 0 1.55.66 2.35 2.35 0 0 0 1.12-.3ZM86.31 42.13a4.06 4.06 0 0 1-1.56-1.57 4.72 4.72 0 0 1-.57-2.34 4.62 4.62 0 0 1 .58-2.34 3.94 3.94 0 0 1 1.6-1.56 4.86 4.86 0 0 1 4.53 0 4.07 4.07 0 0 1 1.61 1.56 4.62 4.62 0 0 1 .59 2.34 4.48 4.48 0 0 1-.6 2.34 4.14 4.14 0 0 1-1.62 1.57 4.73 4.73 0 0 1-2.29.55 4.67 4.67 0 0 1-2.27-.55Zm3.36-1.63a2.11 2.11 0 0 0 .84-.86 2.87 2.87 0 0 0 .31-1.4 2.63 2.63 0 0 0-.64-1.9 2.14 2.14 0 0 0-1.59-.66 2.07 2.07 0 0 0-1.56.66 2.61 2.61 0 0 0-.63 1.9 2.71 2.71 0 0 0 .61 1.9 2 2 0 0 0 1.55.66 2.31 2.31 0 0 0 1.11-.3ZM96.85 30.99V42.5h-2.18V30.99ZM100.71 42.26a3.39 3.39 0 0 1-1.44-1.13 2.9 2.9 0 0 1-.55-1.73h2.34a1.52 1.52 0 0 0 .44 1.1 1.68 1.68 0 0 0 1.18.39 1.85 1.85 0 0 0 1.2-.37 1.19 1.19 0 0 0 .44-1 1.08 1.08 0 0 0-.3-.79 2 2 0 0 0-.74-.49c-.3-.12-.7-.25-1.22-.4a13.82 13.82 0 0 1-1.73-.61 3.13 3.13 0 0 1-1.13-.92 2.62 2.62 0 0 1-.48-1.64 2.9 2.9 0 0 1 .49-1.69 3.05 3.05 0 0 1 1.36-1.1 4.84 4.84 0 0 1 2-.38 4.3 4.3 0 0 1 2.74.82 3.11 3.11 0 0 1 1.19 2.29h-2.41a1.25 1.25 0 0 0-.47-.93 1.77 1.77 0 0 0-1.18-.37 1.42 1.42 0 0 0-1 .34 1.18 1.18 0 0 0-.39 1 1 1 0 0 0 .29.73 2 2 0 0 0 .72.47c.29.12.69.26 1.21.42a11.67 11.67 0 0 1 1.74.62 3.1 3.1 0 0 1 1.15.93 2.65 2.65 0 0 1 .48 1.65 3.09 3.09 0 0 1-.45 1.62 3.16 3.16 0 0 1-1.33 1.19 4.48 4.48 0 0 1-2.07.45 5.76 5.76 0 0 1-2.08-.47ZM111.85 34.15a3.6 3.6 0 0 1 1.69-.4 3.74 3.74 0 0 1 3.42 2.1 5 5 0 0 1 .53 2.33 5.06 5.06 0 0 1-.53 2.35 3.88 3.88 0 0 1-1.41 1.58 3.76 3.76 0 0 1-2 .56 3.43 3.43 0 0 1-1.67-.39 3.56 3.56 0 0 1-1.18-1v5.34h-2.2V33.89h2.18v1.25a3.26 3.26 0 0 1 1.17-.99Zm3.08 2.69a2.2 2.2 0 0 0-.84-.87 2.25 2.25 0 0 0-1.13-.3 2.09 2.09 0 0 0-1.11.31 2.2 2.2 0 0 0-.84.87 3 3 0 0 0 0 2.72 2.16 2.16 0 0 0 .84.88 2.21 2.21 0 0 0 1.11.31 2.06 2.06 0 0 0 1.13-.32 2.23 2.23 0 0 0 .84-.88 2.76 2.76 0 0 0 .33-1.38 2.64 2.64 0 0 0-.33-1.34ZM120.67 42.13a4.08 4.08 0 0 1-1.57-1.57 4.72 4.72 0 0 1-.57-2.34 4.52 4.52 0 0 1 .59-2.34 3.94 3.94 0 0 1 1.6-1.56 4.86 4.86 0 0 1 4.53 0 4.13 4.13 0 0 1 1.6 1.56 4.72 4.72 0 0 1 .58 2.34 4.57 4.57 0 0 1-.59 2.34 4.17 4.17 0 0 1-1.63 1.57 4.7 4.7 0 0 1-2.29.55 4.63 4.63 0 0 1-2.25-.55Zm3.36-1.63a2 2 0 0 0 .83-.86 2.87 2.87 0 0 0 .32-1.4 2.64 2.64 0 0 0-.65-1.9 2.13 2.13 0 0 0-1.58-.66 2.11 2.11 0 0 0-1.57.66 2.66 2.66 0 0 0-.63 1.9 2.72 2.72 0 0 0 .62 1.9 2 2 0 0 0 1.55.66 2.31 2.31 0 0 0 1.11-.3ZM131.57 35.69v4.18a.78.78 0 0 0 .21.63 1 1 0 0 0 .71.19h1v1.81h-1.38c-1.84 0-2.76-.89-2.76-2.68v-4.13h-1v-1.8h1v-2.13h2.2v2.13h1.95v1.8Z"
          className="cls-6"
        />
      </g>
    </g>
    <g id="Counts">
      <path
        id="Badge"
        d="M172 8.73v9.13a.14.14 0 0 0 0 .06 1.26 1.26 0 0 1-2.13.71l-2.74-2.42-.11-.09-.49.43-2.4 2.11A1.25 1.25 0 0 1 162 18V8.62A1.88 1.88 0 0 1 163.9 7h6.2a1.88 1.88 0 0 1 1.81 1.34c.09.13.09.26.09.39Z"
        style={{
          fill: "#347ef0",
        }}
        transform="translate(-.5 -.5)"
      />
      <text
        id="Counts-2"
        data-name="Counts"
        style={{
          fontSize: 12,
          fontWeight: 500,
          fill: "#011367",
        }}
        transform="translate(174.32 16.92)"
      >
        <tspan x={1} y={0}>
          {favCount}
        </tspan>
      </text>
    </g>
  </svg>
    </>
  );
};

export default Promotesvg;
